import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=fc8706a0"
import script from "./menu.js?vue&type=script&lang=js&external"
export * from "./menu.js?vue&type=script&lang=js&external"
import style0 from "./menu.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports